import Vue from 'vue';
import OnbordingApi from '../../api/OnbordingApi';
import OtisApi from '../../api/OtisApi';

const state = {
  otsFlowConfig: null,
  loading: false,
  serverErrors: {
    getFlowConfig: '',
  },
};

const getters = {
  isLoading: state => state.loading,
  hasFlowConfig: state => state.otsFlowConfig !== null,
  flowConfig: state => state.otsFlowConfig,
};

const actions = {
  async isFinishedLoadingCashflow({ commit, dispatch }) {
    const isFinishedLoadingCashflow = await OnbordingApi.isFinishedLoadingCashflow();
    return isFinishedLoadingCashflow;
  },
  async getFlowConfig({ commit, dispatch }, flowId) {
    if (!flowId) {
      commit('setError', { error: 'MISSING_FLOW_ID', functionName: 'getFlowConfig' });
      throw new Error('Flow ID is required');
    }

    commit('setLoading', true);
    commit('resetError', 'getFlowConfig');

    try {
      const flowConfig = await OtisApi.getFlowConfigByFlowId(flowId);
      commit('setOtsFlowConfig', flowConfig);
      return flowConfig;
    } catch (e) {
      dispatch('catchServerError', { e, functionName: 'getFlowConfig' });
      throw e;
    } finally {
      commit('setLoading', false);
    }
  },
  catchServerError({ commit }, { e, functionName }) {
    if (e.response && e.response.status === 400) {
      commit('setError', { error: e.response.data, functionName });
    } else if (e.response && e.response.status === 404) {
      commit('setError', { error: 'FLOW_NOT_FOUND', functionName });
    } else {
      commit('setError', { error: 'UNKNOWN_ERROR', functionName });
    }
  },
  clearFlowConfig({ commit }) {
    commit('setOtsFlowConfig', null);
  },
};

const mutations = {
  setOtsFlowConfig(state, flowConfig) {
    state.otsFlowConfig = flowConfig;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, { error, functionName }) {
    Vue.set(state.serverErrors, functionName, error);
  },
  resetError(state, functionName) {
    Vue.set(state.serverErrors, functionName, '');
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
